/* FRESKOA - 12/10/2026 - Fiches vins : (1) fiche technique en grille + encadre degustation a partir des descriptions existantes, (2) notes de degustation par millesime */
(function () {
  var host = document.querySelector('.product-page--description [itemprop="description"]');
  if (!host) { return; }
  var clean = function (s) { return (s || '').replace(/ /g, ' ').replace(/\s+/g, ' ').trim(); };

  function transform() {
    if (host.querySelector('.fiche-degustation, .fiche-technique')) { return; }
    var root = host.querySelector('[id^="longtexte"]') || host;
    var TECH = [['Millésime', /^mill[ée]sime/i], ['Contenance', /^contenance/i], ['Degré d’alcool', /^degr[ée]/i], ['Type de vin', /^type de vin/i], ['Appellation', /^appellation/i], ['Domaine viticole', /^domaine viticole/i], ['Culture', /^culture/i], ['Allergènes', /^allerg/i]];
    var TASTE = [['couleur', /^couleur/i], ['nez', /^nez\b/i], ['bouche', /^bouche/i], ['service', /^service/i], ['accord', /^accords?\b/i], ['garde', /^garde/i]];
    var PRICE = /^\d+([.,]\d+)?\s*€\s*\/\s*L$/i;
    var isHead = function (n) { return n.nodeType === 1 && /^H[1-6]$/.test(n.tagName); };
    var isBlank = function (n) { return n.nodeType === 3 && !clean(n.textContent); };
    var mk = function (tag, cls, txt) { var e = document.createElement(tag); if (cls) { e.className = cls; } if (txt) { e.textContent = txt; } return e; };
    var tech = {}, taste = {}, remove = [], title = '', firstTech = null, firstTaste = null;
    var heads = Array.prototype.slice.call(root.querySelectorAll('h1,h2,h3,h4,h5,h6'));
    heads.forEach(function (h) {
      if (PRICE.test(clean(h.textContent))) { if (!tech['Prix au litre']) { tech['Prix au litre'] = clean(h.textContent); if (!firstTech) { firstTech = h; } } remove.push(h); return; }
      var t = clean(h.textContent).replace(/^[^A-Za-zÀ-ÿ]+/, '');
      if (/^d[ée]gustation/i.test(t) && !title) { title = clean(h.textContent); remove.push(h); if (!firstTaste) { firstTaste = h; } return; }
      var kind = null, key = null;
      TECH.forEach(function (x) { if (!kind && x[1].test(t)) { kind = 'tech'; key = x[0]; } });
      TASTE.forEach(function (x) { if (!kind && x[1].test(t)) { kind = 'taste'; key = x[0]; } });
      if (!kind) { return; }
      var i = t.indexOf(':'); var value = i > -1 ? clean(t.slice(i + 1)) : '';
      var nodes = [h], frag = [];
      if (!value) {
        var n = h.nextSibling;
        while (n && isBlank(n)) { nodes.push(n); n = n.nextSibling; }
        if (!n && h.parentNode && h.parentNode.tagName === 'LI') {
          nodes.push(h.parentNode);
          n = h.parentNode.nextSibling;
          while (n && isBlank(n)) { nodes.push(n); n = n.nextSibling; }
        }
        var parts = [];
        while (n && !isHead(n)) {
          if (n.nodeType === 1 && /^(UL|OL)$/.test(n.tagName) && kind === 'taste') {
            parts.push(clean(n.textContent)); frag.push(n.cloneNode(true)); nodes.push(n); n = n.nextSibling; break;
          }
          if (n.nodeType === 1 && /^(UL|OL|LI|DIV|SECTION)$/.test(n.tagName)) { break; }
          var tx = clean(n.textContent);
          if (tx) {
            parts.push(tx);
            if (kind === 'taste') { if (n.nodeType === 1 && n.tagName === 'P') { frag.push(n.cloneNode(true)); } else { frag.push(mk('p', '', tx)); } }
          }
          nodes.push(n);
          n = n.nextSibling;
          if (kind === 'tech' && parts.length) { break; }
        }
        value = parts.join(' ');
      } else if (kind === 'taste') { frag.push(mk('p', '', value)); }
      if (!value) { if (kind === 'tech') { nodes.forEach(function (x) { remove.push(x); }); } return; }
      if (kind === 'tech') { if (!tech[key]) { tech[key] = value; if (!firstTech) { firstTech = h; } } } else { if (!taste[key]) { taste[key] = frag; if (!firstTaste) { firstTaste = h; } } }
      nodes.forEach(function (x) { remove.push(x); });
    });
    Array.prototype.slice.call(root.querySelectorAll('li')).forEach(function (li) {
      if (li.querySelector('h1,h2,h3,h4,h5,h6') || remove.indexOf(li) > -1) { return; }
      var t = clean(li.textContent), m = t.match(/^([^:]{3,25}):\s*(.+)$/), key = null, tkey = null;
      if (m) {
        TECH.forEach(function (x) { if (!key && x[1].test(m[1])) { key = x[0]; } });
        if (key) { if (!tech[key]) { tech[key] = clean(m[2]); if (!firstTech) { firstTech = li; } remove.push(li); } return; }
        TASTE.forEach(function (x) { if (!tkey && x[1].test(m[1])) { tkey = x[0]; } });
        if (tkey && !taste[tkey]) { taste[tkey] = [mk('p', '', clean(m[2]))]; if (!firstTaste) { firstTaste = li; } remove.push(li); }
      } else if (PRICE.test(t) && !tech['Prix au litre']) { tech['Prix au litre'] = t; remove.push(li); }
    });
    var ORDER = TECH.map(function (x) { return x[0]; }).concat(['Prix au litre']);
    var techKeys = ORDER.filter(function (k) { return tech[k]; });
    var tasteCount = Object.keys(taste).length;
    if (techKeys.length < 2 && tasteCount < 2) { return; }
    var top = function (el) { while (el && el.parentNode !== root) { el = el.parentNode; } return el; };
    var block = function (label, frag) { var d = mk('div'); d.appendChild(mk('h5', '', label)); frag.forEach(function (f) { d.appendChild(f); }); return d; };
    var ul = null, sec = null;
    if (techKeys.length >= 2) {
      ul = mk('ul', 'fiche-technique');
      techKeys.forEach(function (k) { var li = mk('li'); li.appendChild(mk('strong', '', k)); li.appendChild(document.createTextNode(' ' + tech[k])); ul.appendChild(li); });
    }
    if (tasteCount >= 2) {
      sec = mk('section', 'fiche-degustation');
      sec.appendChild(mk('h4', '', title || 'Dégustation'));
      var sens = mk('div', 'degustation-sens');
      [['couleur', 'Couleur'], ['nez', 'Nez'], ['bouche', 'Bouche']].forEach(function (x) { if (taste[x[0]]) { sens.appendChild(block(x[1], taste[x[0]])); } });
      if (sens.children.length) { sec.appendChild(sens); }
      if (taste.accord) { var a = block('Accord mets et vin', taste.accord); a.className = 'degustation-accord'; sec.appendChild(a); }
      var pr = mk('div', 'degustation-pratique');
      [['service', 'Service'], ['garde', 'Garde']].forEach(function (x) { if (taste[x[0]]) { pr.appendChild(block(x[1], taste[x[0]])); } });
      if (pr.children.length) { sec.appendChild(pr); }
    }
    var anchorTech = firstTech && top(firstTech), anchorTaste = firstTaste && top(firstTaste);
    if (ul) { if (anchorTech && anchorTech.parentNode === root) { root.insertBefore(ul, anchorTech); } else { root.insertBefore(ul, root.firstChild); } }
    if (sec) { if (anchorTaste && anchorTaste.parentNode === root) { root.insertBefore(sec, anchorTaste); } else { root.appendChild(sec); } }
    remove.forEach(function (n) { if (n.parentNode) { n.parentNode.removeChild(n); } });
    Array.prototype.slice.call(root.querySelectorAll('h2')).forEach(function (h) {
      if (/^sommaire$/i.test(clean(h.textContent))) { var nx = h.nextElementSibling; h.parentNode.removeChild(h); if (nx && /^(OL|UL)$/.test(nx.tagName)) { nx.parentNode.removeChild(nx); } }
    });
    Array.prototype.slice.call(root.querySelectorAll('ul,ol,li,p')).forEach(function (n) {
      if (n.closest('.fiche-technique, .fiche-degustation')) { return; }
      if (!clean(n.textContent) && !n.querySelector('img')) { n.parentNode.removeChild(n); }
    });
  }

  /* Notes par millesime : une section <section class="fiche-degustation" data-millesimes="2012 2013"> par millesime (ou groupe de millesimes).
     La page affiche celle du millesime choisi ; sans correspondance, elle affiche la premiere avec un avertissement.
     Quand une section couvre plusieurs millesimes, la mention dit que les notes sont communes (le producteur ne publie pas de notes par annee). */
  function millesimes() {
    var secs = Array.prototype.slice.call(host.querySelectorAll('.fiche-degustation[data-millesimes]'));
    if (!secs.length) { return; }
    var select = document.querySelector('.product-form--variant-select');
    var yearOf = function (s) { var m = (s || '').match(/(19|20)\d{2}/); return m ? m[0] : ''; };
    var joinYears = function (l) { return l.length < 2 ? l.join('') : l.slice(0, -1).join(', ') + ' et ' + l[l.length - 1]; };
    /* Le theme ne met pas a jour le select cache au clic : on lit d'abord le bouton choisi, puis ?variant= dans l'adresse, puis le select, puis la fiche technique. */
    var current = function () {
      var y = '';
      var checked = document.querySelector('.product-form--variants input[type="radio"]:checked');
      if (checked) { y = yearOf(checked.value); }
      if (!y && select) {
        var vid = (location.search.match(/[?&]variant=(\d+)/) || [])[1];
        var opt = null;
        Array.prototype.slice.call(select.options).forEach(function (o) { if (vid && o.value === vid) { opt = o; } });
        if (!opt && select.options.length > 1) { opt = select.options[select.selectedIndex]; }
        y = yearOf(opt && opt.text);
      }
      if (!y) { Array.prototype.slice.call(host.querySelectorAll('.fiche-technique li')).forEach(function (li) { if (!y && /^mill[ée]sime/i.test(clean(li.textContent))) { y = yearOf(li.textContent); } }); }
      return y;
    };
    var notice = document.createElement('p');
    notice.className = 'degustation-avertissement';
    var render = function () {
      var y = current(), hit = null;
      secs.forEach(function (s) { if (!hit && y && (s.getAttribute('data-millesimes') || '').split(/\s+/).indexOf(y) > -1) { hit = s; } });
      var shown = hit || secs[0];
      secs.forEach(function (s) { s.hidden = (s !== shown); });
      var list = (shown.getAttribute('data-millesimes') || '').split(/\s+/).filter(Boolean);
      if (hit) {
        notice.textContent = list.length > 1 ? 'Notes communes aux millésimes ' + joinYears(list) + ' (le producteur ne publie pas de notes distinctes par année).' : 'Notes de dégustation du millésime ' + y + '.';
      } else {
        notice.textContent = 'Ces notes portent sur ' + (list.length > 1 ? 'les millésimes ' : 'le millésime ') + joinYears(list) + (y ? ' ; le millésime ' + y + ' peut différer légèrement.' : '.');
      }
      shown.insertBefore(notice, shown.children[1] || null);
    };
    var last = current();
    render();
    setInterval(function () { var y = current(); if (y !== last) { last = y; render(); } }, 400);
  }

  transform();
  millesimes();
})();
